import React from 'react';
import PropTypes from 'prop-types';
import ArrowUpIcon from '@tradera/blueprint/theme/icons2/arrow-up.svg?jsx';
import { useTranslator } from 'tradera-lang';

const handleClick = () => {
    window.scrollTo(0, 0);
};

const ScrollToTopButton = ({ onClick = null }) => {
    const { t } = useTranslator();
    return (
        <div className="d-flex py-3 justify-content-center">
            <a
                role="button"
                className="btn btn-fluid btn-toggle btn--icon-fixed col-lg-2 col-md-4 col-sm-6 col-8"
                onClick={() => {
                    if (onClick != null) onClick();
                    handleClick();
                }}>
                <ArrowUpIcon className="icon icon-before" />
                <span className="ml-3 d-inline">
                    {t('searchResults_backToTop')}
                </span>
            </a>
        </div>
    );
};

ScrollToTopButton.propTypes = {
    onClick: PropTypes.func
};

export default ScrollToTopButton;
